//
//
//
//
//
//
//
//

import QRCode from 'qrcode'
export default {
  name: 'QRimg',
  props: {
    size: {
      type: Number, default: 100
    },
    text: {
      type: String, default: ''
    },
    icon: {
      type: String, default: 'https://resources.interface003.com/cloud/img/eashop/vps-logo.png'
    }
  },
  data () {
    return {
      imgUrl: '' // 二维码图片
    }
  },
  created () {
    this.getQrUrl(this.text)
  },
  methods: {
    async getQrUrl (text = '') {
      try {
        const url = await QRCode.toDataURL(text, { margin: 0 })
        this.imgUrl = url
      } catch (err) {}
    }
  }
}
